const SET_STATES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.estados = payload
  }
}

const SET_CITIES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.cidades[payload.codigo_uf] = payload.cidades
  }
}

export { SET_STATES, SET_CITIES }
